import { useState, useEffect } from 'react';
import { supabase } from '../../../lib/supabase';

const inputStyle = { width: '100%', border: '1.5px solid #DDD', borderRadius: 8, padding: '8px 12px', fontSize: '.86rem', outline: 'none', boxSizing: 'border-box' };

export default function RewardCatalog() {
  const [rewards, setRewards]     = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [form, setForm]           = useState({ menu_item_id: '', points_required: '', stock_limit: '', note: '', is_active: true });
  const [editId, setEditId]       = useState(null);
  const [showForm, setShowForm]   = useState(false);

  useEffect(() => { load(); }, []);

  async function load() {
    const [rewRes, menuRes] = await Promise.all([
      supabase.from('loyalty_reward_catalog').select('*, menu_items(id,name,emoji,base_price,category)').order('points_cost'),
      supabase.from('menu_items').select('id,name,emoji,base_price').eq('is_hidden', false).order('name'),
    ]);
    setRewards(rewRes.data || []);
    setMenuItems(menuRes.data || []);
  }

  async function handleSave() {
    if (!form.menu_item_id || !form.points_required) return;
    const payload = { product_id: form.menu_item_id, points_cost: +form.points_required, stock_limit: form.stock_limit ? +form.stock_limit : null, note: form.note, is_active: !!form.is_active };
    if (editId) {
      await supabase.from('loyalty_reward_catalog').update(payload).eq('id', editId);
    } else {
      // Cek apakah product sudah ada di catalog
      const { data: existing } = await supabase.from('loyalty_reward_catalog').select('id').eq('product_id', form.menu_item_id).maybeSingle();
      if (existing) { alert('Produk ini sudah ada di reward catalog.'); return; }
      await supabase.from('loyalty_reward_catalog').insert(payload);
    }
    reset(); load();
  }

  async function handleDelete(id) {
    if (!window.confirm('Hapus reward ini?')) return;
    await supabase.from('loyalty_reward_catalog').delete().eq('id', id);
    load();
  }

  async function toggleActive(r) {
    await supabase.from('loyalty_reward_catalog').update({ is_active: !r.is_active }).eq('id', r.id);
    load();
  }

  function handleEdit(r) {
    setForm({ menu_item_id: r.menu_items?.id || '', points_required: r.points_cost, stock_limit: r.stock_limit || '', note: r.note || '', is_active: r.is_active });
    setEditId(r.id); setShowForm(true); window.scrollTo(0, 0);
  }

  function reset() { setForm({ menu_item_id: '', points_required: '', stock_limit: '', note: '', is_active: true }); setEditId(null); setShowForm(false); }
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const stockRemaining = (r) => r.stock_limit != null ? r.stock_limit - (r.stock_used || 0) : null;

  return (
    <div style={{ padding: 'clamp(16px,4vw,28px) clamp(12px,4vw,24px) 60px' }}>
      <style>{`@media(max-width:580px){.rew-grid{grid-template-columns:1fr!important}}`}</style>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
        <div>
          <div style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1.5rem' }}>Reward Catalog</div>
          <div style={{ fontSize: '.82rem', color: 'var(--muted)' }}>Produk yang bisa ditukar dengan poin loyalty</div>
        </div>
        <button onClick={() => { reset(); setShowForm(true); }} style={{ padding: '9px 18px', borderRadius: 8, background: '#CD5226', color: '#fff', border: 'none', fontSize: '.84rem', fontFamily: "'DM Sans',sans-serif", cursor: 'pointer' }}>+ Tambah Reward</button>
      </div>

      {showForm && (
        <div className="fade-up" style={{ background: 'white', borderRadius: 'var(--radius)', border: '1px solid var(--border)', padding: '22px', marginBottom: 20, boxShadow: 'var(--shadow)' }}>
          <div style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1.1rem', marginBottom: 18 }}>{editId ? 'Edit Reward' : 'Reward Baru'}</div>
          <div className="rew-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
            <div style={{ gridColumn: editId ? 'auto' : '1/-1' }}>
              <label style={{ display: 'block', fontSize: '.74rem', color: 'var(--muted)', marginBottom: 4 }}>Produk (Menu POS) *</label>
              <select value={form.menu_item_id} onChange={e => set('menu_item_id', e.target.value)} style={inputStyle} disabled={!!editId}>
                <option value="">Pilih produk...</option>
                {menuItems.map(m => <option key={m.id} value={m.id}>{m.emoji} {m.name} — Rp {(m.base_price||0).toLocaleString('id-ID')}</option>)}
              </select>
            </div>
            <div><label style={{ display: 'block', fontSize: '.74rem', color: 'var(--muted)', marginBottom: 4 }}>Poin Dibutuhkan *</label><input type="number" value={form.points_required} onChange={e => set('points_required', e.target.value)} placeholder="50" style={inputStyle} /></div>
            <div><label style={{ display: 'block', fontSize: '.74rem', color: 'var(--muted)', marginBottom: 4 }}>Batas Stok (kosongkan = unlimited)</label><input type="number" value={form.stock_limit} onChange={e => set('stock_limit', e.target.value)} placeholder="Unlimited" style={inputStyle} /></div>
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: '.74rem', color: 'var(--muted)', marginBottom: 4 }}>Catatan</label>
            <input value={form.note} onChange={e => set('note', e.target.value)} placeholder="e.g. Berlaku khusus member Sahabat ke atas" style={inputStyle} />
          </div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: '.82rem', marginBottom: 16, cursor: 'pointer' }}>
            <input type="checkbox" checked={!!form.is_active} onChange={e => set('is_active', e.target.checked)} /> Aktif
          </label>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
            <button onClick={reset} style={{ padding: '8px 16px', borderRadius: 8, background: 'var(--cream)', border: '1px solid var(--border)', fontSize: '.82rem', cursor: 'pointer', color: 'var(--muted)' }}>Batal</button>
            <button onClick={handleSave} style={{ padding: '8px 18px', borderRadius: 8, background: '#CD5226', color: '#fff', border: 'none', fontSize: '.82rem', cursor: 'pointer' }}>{editId ? 'Simpan' : 'Tambah Reward'}</button>
          </div>
        </div>
      )}

      {rewards.map(r => {
        const remaining = stockRemaining(r);
        return (
          <div key={r.id} style={{ background: 'white', borderRadius: 'var(--radius)', border: '1px solid var(--border)', padding: '14px 18px', marginBottom: 10, boxShadow: 'var(--shadow)', opacity: r.is_active ? 1 : 0.6 }}>
            <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
              <div style={{ fontSize: 28, lineHeight: 1, flexShrink: 0 }}>{r.menu_items?.emoji || '🎁'}</div>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ fontWeight: 500, fontSize: '.9rem' }}>{r.menu_items?.name || '—'}</div>
                  <div style={{ fontFamily: "'DM Mono',monospace", fontSize: '.8rem', color: 'var(--gold)', background: 'rgba(201,146,42,.1)', padding: '2px 10px', borderRadius: 20 }}>{r.points_cost} poin</div>
                </div>
                <div style={{ fontSize: '.76rem', color: 'var(--muted)', marginTop: 2 }}>
                  Rp {(r.menu_items?.base_price||0).toLocaleString('id-ID')} · {r.menu_items?.category}
                  {remaining !== null && <span style={{ marginLeft: 8, color: remaining <= 5 ? '#C62828' : 'var(--muted)' }}>Stok sisa: {remaining}</span>}
                  {remaining === null && <span style={{ marginLeft: 8 }}>Stok: Unlimited</span>}
                  {r.note && <span style={{ marginLeft: 8 }}>· {r.note}</span>}
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => toggleActive(r)} style={{ padding: '4px 10px', borderRadius: 6, background: r.is_active ? '#FFF3E0' : '#E8F5E9', border: `1px solid ${r.is_active ? '#FFCC80' : '#A5D6A7'}`, color: r.is_active ? '#E65100' : '#1B5E20', fontSize: '.72rem', cursor: 'pointer' }}>
                {r.is_active ? 'Nonaktifkan' : 'Aktifkan'}
              </button>
              <button onClick={() => handleEdit(r)} style={{ padding: '4px 10px', borderRadius: 6, background: 'var(--cream)', border: '1px solid var(--border)', fontSize: '.72rem', cursor: 'pointer' }}>Edit</button>
              <button onClick={() => handleDelete(r.id)} style={{ padding: '4px 10px', borderRadius: 6, background: '#FFEBEE', border: '1px solid #FFCDD2', color: '#C62828', fontSize: '.72rem', cursor: 'pointer' }}>Hapus</button>
            </div>
          </div>
        );
      })}
      {rewards.length === 0 && !showForm && <div style={{ textAlign: 'center', padding: 40, color: 'var(--muted)', fontSize: '.84rem' }}>Belum ada reward. Tambahkan produk ke catalog.</div>}
    </div>
  );
}
